import * as actions from 'actions/importJobUpload';

export const defaultState = {
  posting: false,
  error: null,
};

function getErrorId(action) {
  const { status } = action.response;

  // TODO: when backend supports subcodes to specify the generic error, map those
  // correctly (IMPORT_UPLOAD_ERROR_EMPTY_FILE, IMPORT_UPLOAD_ERROR_TOO_LONG)
  return status === 429
    ? 'IMPORT_UPLOAD_ERROR_TOO_MANY_REQUESTS'
    : 'IMPORT_UPLOAD_ERROR_GENERIC';
}

export default function importJobUpload(state = defaultState, action) {
  switch (action.type) {
    case actions.POST_IMPORT_START: {
      return {
        ...state,
        posting: true,
        error: null,
      };
    }
    case actions.POST_IMPORT_SUCCESS: {
      return {
        posting: false,
        error: null,
      };
    }
    case actions.POST_IMPORT_FAIL: {
      return {
        ...state,
        posting: false,
        error: getErrorId(action),
      };
    }
    case actions.CLEAR_UPLOAD_ERROR_STATE: {
      return { ...state, error: null };
    }
    default:
      return state;
  }
}
